var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1162 3.24711C20.4319 2.81501 19.5888 2.76934 18.8629 3.12604L16.9532 4.06274C16.6621 1.98851 14.8954 0.386261 12.7593 0.386261H5.03127C2.69318 0.386261 0.790649 2.30461 0.790649 4.66376V10.537C0.790649 12.8954 2.69246 14.8145 5.03127 14.8145H12.76C14.8954 14.8145 16.6628 13.2122 16.9539 11.138L18.8636 12.0747C19.1885 12.2342 19.5364 12.3132 19.8828 12.3132C20.3112 12.3132 20.7381 12.1922 21.1162 11.9536C21.8004 11.5215 22.2094 10.7777 22.2094 9.96279V5.23796C22.2094 4.42306 21.8012 3.67921 21.1162 3.24711ZM15.7069 10.5363C15.7069 12.1755 14.3851 13.5088 12.76 13.5088H5.03127C3.40618 13.5088 2.0844 12.1755 2.0844 10.5363V4.66376C2.0844 3.02454 3.40618 1.69126 5.03127 1.69126H12.76C14.3851 1.69126 15.7069 3.02454 15.7069 4.66376V10.5363ZM20.9157 9.96206C20.9157 10.3289 20.7381 10.6515 20.4298 10.8466C20.1207 11.0416 19.7556 11.0612 19.4286 10.9002L16.9999 9.70904V5.49099L19.4286 4.29981C19.7556 4.13814 20.1207 4.15844 20.4298 4.35346C20.7388 4.54849 20.9157 4.87039 20.9157 5.23724V9.96206Z",
    fill: "#303E4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.fe070c9716111c2edbdda9fab59e0743.svg";
export { ForwardRef as ReactComponent };